import React, { memo } from 'react';
import { Loader } from 'semantic-ui-react';
import { Text, Separator } from '@cuemath/web-comps';
import { FlexView } from '@cuemath/comps';

import { Heading, Table } from 'comps';
import { AV_REVIEW_ROLES } from 'constants/av-review';
import COLORS from 'constants/colors';
import maintenanceIcon from 'img/maintenance.svg';

import useAVReviewRole from '../av-review-dashboard/hooks/use-av-review-role';
import useReviewerConfig from './hooks/use-reviewer-config';
import ReviewerRow from './components/reviewer-row';
import { StateContainer, ActionRow, SaveButton } from './av-review-settings-styled';
import { HEADER_CELLS } from './constants';

function AVReviewSettings() {
  const { role } = useAVReviewRole();
  const {
    reviewers,
    isLoading,
    isSaving,
    validationError,
    updateReviewer,
    submit,
  } = useReviewerConfig();

  if (isLoading) {
    return (
      <StateContainer justifyContent="center" alignItems="center">
        <Loader inline active />
      </StateContainer>
    );
  }

  if (role !== AV_REVIEW_ROLES.ADMIN) {
    return (
      <StateContainer justifyContent="center" alignItems="center">
        <img src={maintenanceIcon} alt="No access" width={120} height={72} />
        <Separator transparent height={16} />
        <Text variant="body1Regular" color={COLORS.SILVERCHALICE}>
          You do not have access to AV Review Settings.
        </Text>
      </StateContainer>
    );
  }

  return (
    <FlexView gap={16} gutter={16}>
      <Heading>AV Review Settings</Heading>
      <Separator transparent height={8} />
      <Text variant="body2" color={COLORS.BLACK}>
        Edit reviewer capacity weight, and on-leave status. New
        assignments are skipped for reviewers marked on leave; weight controls
        the share of new assignments each reviewer receives.
      </Text>
      <Separator height={24} />
      <Table
        headerCell={HEADER_CELLS}
        dataLength={reviewers.length}
        showInfo={false}
        noDataMessage="No reviewers configured."
      >
        {reviewers.map(reviewer => (
          <ReviewerRow
            key={reviewer.id}
            reviewer={reviewer}
            disabled={isSaving}
            onUpdate={updateReviewer}
          />
        ))}
      </Table>
      <ActionRow flexDirection="row" justifyContent="flex-end" alignItems="center" gap={24}>
        {validationError && !isSaving && (
          <Text variant="body3" color={COLORS.RED}>
            {validationError}
          </Text>
        )}
        <SaveButton
          disabled={isSaving || !!validationError}
          onClick={submit}
          size="small"
          label="Save"
          isBusy={isSaving}
        />
      </ActionRow>
    </FlexView>
  );
}

export default memo(AVReviewSettings);
